<template>
  <div>
    <div
      class="modal fade"
      id="editWaveDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ lang.WV0000 }}</b>
            </h4>
            <p>
              <b>{{ lang.WV0024 }}:</b>
              {{ selectedProjectData.ProjectId }} -
              {{ selectedProjectData.ProjectName }},
              <b>{{ lang.WV0025 }}:</b>
              {{ selectedProjectData.ClientId }} -
              {{ selectedProjectData.ClientName }}
            </p>
          </div>
          <div class="modal-body">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="col-md-6" style="padding-left: 0">
                  <!-- Searchbar - triggered by enter key -->
                  <div
                    class="form-group searchbar col-md-6"
                    style="padding-left: 15px"
                  >
                    <input
                      type="search"
                      class="form-control"
                      id="inputSearchFilter"
                      :placeholder="lang.WV0001"
                      v-model="filterWaveString"
                      @input="doFilteringWaves()"
                    />
                  </div>
                  <div
                    class="form-group searchbar col-md-6"
                    style="padding-left: 15px"
                  >
                    <button
                      type="button"
                      class="btn btn-raised btn-default"
                      :class="{ 'btn-warning': wavePositionsDirty }"
                      @click="saveWavePositions()"
                    >
                      {{ lang.WV0026 }}
                    </button>
                  </div>
                  <!-- Wave table -->
                  <div class="table-container table-waves" style="clear: both">
                    <table
                      class="table table-striped table-hover"
                      id="wavesTable"
                    >
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 10%">
                            {{ lang.WV0002 }}
                          </th>
                          <th class="text-center" style="width: 35%">
                            {{ lang.WV0003 }}
                          </th>
                          <th class="text-center" style="width: 15%">
                            {{ lang.WV0004 }}
                          </th>
                          <th class="text-center" style="width: 15%">
                            {{ lang.WV0005 }}
                          </th>
                          <th class="text-center" style="width: 10%">
                            {{ lang.WV0027 }}
                          </th>
                          <th class="text-center" style="width: 15%">
                            {{ lang.WV0039 }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          role="button"
                          :key="wave.WaveGuid"
                          @click="selectWave(wave.WaveGuid)"
                          :class="{ info: isWaveSelected(wave.WaveGuid) }"
                          v-for="wave in filteredWaves"
                        >
                          <td>{{ wave.WaveId }}</td>
                          <td>{{ wave.WaveName }}</td>
                          <td>
                            {{
                              globals.getLocalizedDateFromIsoTimestamp(
                                wave.WaveSince
                              )
                            }}
                          </td>
                          <td>
                            {{
                              globals.getLocalizedDateFromIsoTimestamp(
                                wave.WaveUntil
                              )
                            }}
                          </td>
                          <td class="nopadding">
                            <div class="form-group nopadding">
                              <select
                                class="form-control text-center nopadding"
                                v-model="wave.WavePosition"
                                @change="reorderWaves(), (wavePositionsDirty = true)"
                                @click.stop
                              >
                                <option
                                  v-for="w in waves"
                                  :key="w.WavePosition"
                                  :value="w.WavePosition"
                                >
                                  {{ w.WavePosition }}
                                </option>
                              </select>
                            </div>
                          </td>
                          <td class="nopadding">
                            <div
                              class="form-group nopadding"
                              style="width: 90%; margin-left: 5px"
                            >
                              <select
                                :id="'inputWaveEditLeadAgency_' + wave.WaveId"                               
                                class="form-control"
                                v-model="wave.LeadAgencyId"
                                :allowClear="true"
                              >
                                <option></option>
                                <option
                                  v-for="agency in leadAgencies"
                                  :key="agency.AgencyId"
                                  :value="agency.AgencyId"
                                >
                                  {{ agency.AgencyName }}
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-6" style="padding-right: 0">
                  <ul
                    class="nav nav-tabs nav-wave-edit"
                    style="margin-bottom: 15px"
                  >
                    <li class="active">
                      <a
                        href="#editWaveTab"
                        id="project-management-wave-edit-add-wave-tab"
                        data-toggle="tab"
                        @click="selectedTab = 'editWaveTab'"
                      >{{ lang.WV0006 }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="#assignScenariosTab"
                        id="project-management-wave-edit-assign-scenarios-tab"
                        data-toggle="tab"
                        @click="selectedTab = 'assignScenariosTab'"
                      >{{ lang.WV0007 }}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#carModelDistributionTab"
                        data-toggle="tab"
                        v-if="carModelList.length > 0"
                        @click="selectedTab = 'carModelDistributionTab'"
                      >{{ lang.WV0029 }}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#competitorCarModelDistributionTab"
                        data-toggle="tab"
                        v-if="feature.isAudiTarget && feature.isEnabled('shopperApproval')"
                        @click="selectedTab = 'competitorCarModelDistributionTab'"
                      >{{ lang.WV0035 }}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#brandVisitsTab"
                        data-toggle="tab"
                        v-if="feature.isAudiTarget"
                        @click="selectedTab = 'brandVisitsTab'"
                      >{{ lang.WV0045 }}
                      </a>
                    </li>
                  </ul>

                  <div class="tab-content">
                    <div class="tab-pane fade active in" id="editWaveTab">
                      <div class="form-group">
                        <label
                          for="inputWaveName"
                          class="col-md-3 control-label"
                          >{{ lang.WV0003 }}</label
                        >
                        <div class="col-md-9">
                          <input
                            type="text"
                            class="form-control"
                            id="inputWaveName"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WaveName"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputWaveStartDate"
                          class="col-md-3 control-label"
                          >{{ lang.WV0004 }}</label>
                        <div
                          class="col-md-9"
                          @click="globals.toggleFlatpickr('inputWaveStartDate')"
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputWaveStartDate"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WaveSince"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputWaveEndDate"
                          class="col-md-3 control-label"
                        >{{ lang.WV0005 }}</label>
                        <div
                          class="col-md-9"
                          @click="globals.toggleFlatpickr('inputWaveEndDate')"
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputWaveEndDate"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WaveUntil"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputWavePlannedStartDate"
                          class="col-md-3 control-label"
                          >{{ lang.WV0042 }}</label>
                        <div
                          class="col-md-9"
                          @click="globals.toggleFlatpickr('inputWavePlannedStartDate')"
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputWavePlannedStartDate"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WavePlannedSince"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputWavePlannedEndDate"
                          class="col-md-3 control-label"
                        >{{ lang.WV0043 }}</label>
                        <div
                          class="col-md-9"
                          @click="globals.toggleFlatpickr('inputWavePlannedEndDate')"
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputWavePlannedEndDate"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WavePlannedUntil"
                          />
                        </div>
                      </div>
                      <!-- <div class="form-group">
                        <label
                          for="inputWaveEditLeadAgeny"
                          class="col-md-3 control-label"
                          >{{ lang.WV0039 }}</label
                        >
                        <div class="col-md-9">
                          <select2
                            id="inputWaveEditLeadAgeny"
                            class="form-control"
                            v-model="selectedWave.LeadAgencyId"
                            @change="selectedWaveDirty = true"
                          >
                            <option></option>
                            <option
                              v-for="agency in leadAgencies"
                              :key="agency.AgencyId"
                              :value="parseInt(agency.AgencyId)"
                            >
                              {{ agency.AgencyName }}
                            </option>
                          </select2>
                        </div>
                      </div> -->
                      <div class="form-group" v-if="!feature.isAudiTarget">
                        <label
                          for="inputWaveEditCostCenter"
                          class="col-md-3 control-label"
                        >{{ lang.WV0028 }}</label>
                        <div class="col-md-9">
                          <input
                            type="text"
                            class="form-control"
                            id="inputWaveEditCostCenter"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.CostCenter"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputWaveEditWaveInfo"
                          class="col-md-3 control-label"
                        >{{ lang.WV0033 }}</label>
                        <div class="col-md-9">
                          <textarea
                            type="text"
                            class="form-control"
                            id="inputWaveEditWaveInfo"
                            maxlength="500"
                            rows="4"
                            @input="selectedWaveDirty = true"
                            v-model="selectedWave.WaveInfo"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <!-- CHECKBOX Reporting Visibility -->
                        <div class="row">
                          <label
                            for="inputWaveReportingVisibility"
                            class="col-md-3 control-label"
                          >{{ lang.WV0008 }}</label>
                          <div
                            class="checkbox"
                            style="float: left; margin-left: 15px"
                          >
                            <label>
                              <input
                                type="checkbox"
                                id="inputWaveReportingVisibility"
                                @input="selectedWaveDirty = true"
                                @change="waveReportingVisibilityChanged(selectedWave)"
                                v-model="selectedWave.ReportingVisibility"
                              />
                              <span class="checkbox-material">
                                <span class="check"></span>
                              </span>
                            </label>
                          </div>
                        </div>
                        
                        <!-- CHECKBOX Wave wo approval -->
                        <div class="row">
                          <label
                            for="inputWaveWithoutApprovel"
                            class="col-md-3 control-label"
                          >{{ lang.WV0040 }}</label>
                          <div
                            class="checkbox"
                            style="float: left; margin-left: 15px"
                          >
                            <label>
                              <input
                                type="checkbox"
                                id="inputWaveWithoutApprovel"
                                @input="selectedWaveDirty = true"
                                v-model="selectedWave.WaveWithoutApprovel"
                              />
                              <span class="checkbox-material">
                                <span class="check"></span>
                              </span>
                            </label>
                          </div>
                        </div>

                        <!-- CHECKBOX Local Wave -->
                        <div class="row">
                          <label
                            for="inputLocalWave"
                            class="col-md-3 control-label"
                          >{{ lang.WV0041 }}</label>
                          <div
                            class="checkbox"
                            style="float: left; margin-left: 15px"
                          >
                            <label>
                              <input
                                type="checkbox"
                                id="inputLocalWave"
                                @input="selectedWaveDirty = true"
                                v-model="selectedWave.IsLocalWave"
                              />
                              <span class="checkbox-material">
                                <span class="check"></span>
                              </span>
                            </label>
                          </div>
                        </div>

                      </div>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar"
                        @click="createNewWave()"
                        :disabled="!selectedWave.WaveName"
                      >
                        <i class="material-icons md-36">add_box</i>
                        <br />
                        {{ lang.WV0009 }}
                      </button>
                      <button
                        id="project-management-wave-save"
                        type="button"
                        class="btn btn-raised btn-success btn-top-bar"
                        @click="saveSelectedWave()"
                        :class="{ 'btn-warning': selectedWaveDirty }"
                        :disabled="!canSaveWave()"
                      >
                        <i class="material-icons md-36">save</i>
                        <br />
                        {{ lang.WV0010 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar"
                        @click="openDeleteWaveConfirmationDialog()"
                        :disabled="!selectedWave.WaveId || !globals.isAccessAllowed('LoopOp_ProjectWaves_Delete')"
                      >
                        <i class="material-icons md-36">delete</i>
                        <br />
                        {{ lang.WV0011 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar"
                        @click="showWaveStatus()"
                        :disabled="!selectedWave.WaveId"
                      >
                        <i class="material-icons md-36">insert_chart</i>
                        <br />
                        {{ lang.WV0034 }}
                      </button>
                    </div>

                    <div class="tab-pane fade" id="assignScenariosTab">
                      <!-- Searchbar - triggered by enter key -->
                      <div
                        class="form-group searchbar"
                        style="margin-right: 15px"
                      >
                        <input
                          type="search"
                          class="form-control"
                          style="max-width: 40%; display: inline; float: left"
                          :placeholder="lang.WV0001"
                          v-model="filterScenarioString"
                          @input="doFilteringScenarios()"
                        />
                        <button
                          id="saveAssignment"
                          type="button"
                          class="btn btn-raised btn-success"
                          style="float: right"
                          :class="{ 'btn-warning': selectedWaveDirty }"
                          @click="saveSelectedWave()"
                          :disabled="!canSaveWave()"
                        >
                          {{ lang.WV0010 }}
                        </button>
                      </div>
                      <!-- Scenario table -->
                      <div class="table-container">
                        <table
                          class="table table-striped table-hover"
                          id="scenarioTable"
                        >
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 10%">
                                {{ lang.WV0012 }}
                              </th>
                              <th class="text-center" style="width: 30%">
                                {{ lang.WV0013 }}
                              </th>
                              <th class="text-center" style="width: 60%">
                                {{ lang.WV0014 }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              role="button"
                              :key="scenario.ScenarioGuid"
                              @click="selectScenario(scenario.ScenarioGuid)"
                              :class="{
                                info: isScenarioSelected(scenario.ScenarioGuid),
                                'cursor-not-allowed': !selectedWave.WaveId,
                              }"
                              v-for="scenario in filteredScenarios"
                            >
                              <td style="width: 10%">
                                {{ scenario.ScenarioId }}
                              </td>
                              <td style="width: 30%">
                                {{ scenario.ScenarioName }}
                              </td>
                              <td style="width: 60%">
                                {{ scenario.ScenarioDescription }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div
                      class="tab-pane fade"
                      id="carModelDistributionTab"
                      v-if="carModelList.length > 0"
                    >
                      <div class="table-container">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 25%">
                                {{ lang.WV0030 }}
                              </th>
                              <th class="text-center" style="width: 25%">{{ lang.SA0012 }}</th>
                              <th class="text-center" style="width: 25%">{{ lang.CMM002 }}</th>
                              <th class="text-center" style="width: 25%">
                                {{ lang.WV0031 }} (%)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              :key="model.CarModelGuid"
                              v-for="model in carModelList"
                            >
                              <td>{{ model.CarModelName }}</td>
                              <td>
                                <div v-if="model.ImporterGuid">
                                  <template v-for="importer in importerList">
                                    <div v-if="importer.ImporterGuid === model.ImporterGuid" :key="importer.ImporterGuid">
                                      {{ importer.ImporterName }}
                                    </div>
                                  </template>
                                </div>
                              </td>
                              <td>
                                <span v-for="(modelCarSegment, index) in model.CarSegments" :key="modelCarSegment.CarSegmentGuid">
                                  <template v-for="segment in segmentList">
                                    <span v-if="segment.CarSegmentGuid === modelCarSegment.CarSegmentGuid" :key="segment.CarSegmentGuid">
                                      <span v-if="index != 0"> ,</span>
                                      {{ segment.CarSegmentName }}
                                    </span>
                                  </template>
                                </span>
                              </td>
                              <td class="nopadding">
                                <div class="form-group nopadding">
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    class="form-control text-center nopadding"
                                    v-model.number="model.Distribution"
                                    @change="(selectedWaveDirty = true), validateDistributionValue(model, 'audi')"
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised btn-success"
                        style="float: right; margin-right: 20px"
                        :class="{ 'btn-warning': selectedWaveDirty }"
                        @click="saveSelectedWave()"
                        :disabled="!canSaveWave()"
                      >
                        {{ lang.WV0010 }}
                      </button>
                    </div>

                    <div
                      class="tab-pane fade"
                      id="competitorCarModelDistributionTab"
                      v-if="feature.isAudiTarget && feature.isEnabled('shopperApproval')"
                    >
                      <div class="table-container">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 15%">
                                {{ lang.WV0044 }}
                              </th>
                              <th class="text-center" style="width: 40%">
                                {{ lang.WV0030 }}
                              </th>
                              <th class="text-center" style="width: 35%">
                                {{ lang.WV0031 }} (%)
                              </th>
                              <th class="text-center" style="width: 10%">
                                {{ lang.WV0036 }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(model, index) in selectedWave.CompetitorCarModelDistribution"
                              :key="index"
                            >
                              <td class="nopadding">
                                <div class="form-group nopadding">
                                  <select
                                    :key="model.CompetitorCarBrand"
                                    class="form-control"
                                    v-model="model.CompetitorCarBrand"
                                    :allowClear="true"
                                    @change="selectedWaveDirty = true"
                                  >
                                    <option disabled value="">{{ lang.WV0048 }}</option>
                                    <option
                                      v-for="brand in brands"
                                      :key="brand"
                                      :value="brand"
                                    >
                                      {{ brand }}
                                    </option>
                                  </select>
                                </div>
                              </td>
                              <td class="nopadding">
                                <div class="form-group nopadding">
                                  <input
                                    type="text"
                                    maxlength="200"
                                    class="form-control text-center nopadding"
                                    v-model="model.CompetitorCarModel"
                                    @change="selectedWaveDirty = true"
                                  />
                                </div>
                              </td>
                              <td class="nopadding">
                                <div class="form-group nopadding">
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    class="form-control text-center nopadding"
                                    :value="parseFloat(((model.Distribution || 0) * 100).toFixed(4))"
                                    @change="(
                                      model.Distribution = ($event.target.value || 0) / 100), 
                                      (selectedWaveDirty = true), 
                                      validateDistributionValue(model,'competitor')"
                                  />
                                </div>
                              </td>
                              <td>
                                <button
                                  class="btn nopadding"
                                  @click="deleteCompetitorCarModel(index)"
                                >
                                  <i class="material-icons md-24 text-red"
                                  >clear</i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <span style="float: right; margin-right:25px" 
                          id="competitorDistributionsInfo"
                          v-if="getCompetitorDistributionsInfoToolTip().length > 0"
                        >
                          <i class="material-icons md-24 text-info" style="cursor: pointer"
                          >info</i>
                          <b-tooltip
                            ref="tooltip"
                            target="competitorDistributionsInfo"
                            :delay="globals.tooltipDelay"
                            triggers="hover"
                            >
                              <template v-for="line in getCompetitorDistributionsInfoToolTip()">
                                {{ line }} <br/>
                              </template>
                          </b-tooltip>
                        </span>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised"
                        style="float: left; margin-left: 20px"
                        @click="addCompetitorCarModel()"
                        :disabled="!selectedWave.WaveName"
                      >
                        {{ lang.WV0037 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-success"
                        style="float: right; margin-right: 20px"
                        :class="{ 'btn-warning': selectedWaveDirty }"
                        @click="saveSelectedWave()"                        
                        :disabled="!canSaveWave()"
                      >
                        {{ lang.WV0010 }}
                      </button>
                    </div>
                    <div
                    class="tab-pane fade"
                    id="brandVisitsTab"
                    v-if="feature.isAudiTarget"
                    >
                    
                      <div class="table-container">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th style="width: 15%">
                                &nbsp;
                              </th>
                              <th class="text-right" style="width: 40%">
                                {{ lang.WV0046 }}
                              </th>
                              <th class="text-right" style="width: 35%">
                                {{ lang.WV0051 }}
                              </th>
                              <th class="text-center" style="width: 10%">
                                {{ lang.WV0036 }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-for="(model, index) in selectedWave.BrandVisits">
                              <tr>
                                <td class="nopadding">
                                  <div class="form-group nopadding">
                                    <select
                                      :key="model.BrandName"
                                      class="form-control"
                                      v-model="model.BrandName"
                                      :allowClear="true"
                                      @change="selectedWaveDirty = true"
                                    >
                                      <option disabled value="">{{ lang.WV0048 }}</option>
                                      <option                                    
                                        :disabled="canSelectBrand(selectedWave, 'Audi')"
                                      >
                                        Audi
                                      </option>
                                      <option
                                        v-for="brand in brands"
                                        :key="brand"
                                        :value="brand"
                                        :disabled="canSelectBrand(selectedWave, brand)"
                                      >
                                        {{ brand }}
                                      </option>
                                    </select>
                                  </div>
                                </td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>
                                  <button
                                    class="btn nopadding"
                                    @click="addVisitToBrandVisit(model)"
                                  >
                                    <i class="material-icons md-24 text-green">add</i>
                                  </button>
                                  <button
                                    class="btn nopadding"
                                    @click="removeBrandVisit(selectedWave, index)"
                                  >
                                    <i class="material-icons md-24 text-red">remove</i>
                                  </button>
                                </td>
                              </tr>
                              <tr v-for="(visit, idx) in model.Visits">
                                <td>&nbsp;</td>
                                <td class="nopadding">
                                  <div class="form-group nopadding">
                                    <input 
                                      type="number" 
                                      min="0" 
                                      max="100" 
                                      class="form-control text-right nopadding"
                                      v-model="visit.Frequency"
                                      @input="(selectedWaveDirty = true, visit.Frequency = validateVisitValue(visit.Frequency))"/>
                                  </div>
                                </td>
                                <td class="nopadding">
                                  <input 
                                    type="number"
                                    min="0"
                                    max="100"
                                    class="form-control text-right nopadding"
                                    v-model="visit.NoOfVisits"
                                    @input="(selectedWaveDirty = true, visit.NoOfVisits = validateVisitValue(visit.NoOfVisits))"/>
                                </td>
                                <td>
                                  <button
                                    class="btn nopadding"
                                    @click="removeVisit(selectedWave, index, idx)"
                                    :disabled="!canRemoveVisit(selectedWave, index)"
                                  >
                                    <i class="material-icons md-24 text-red">remove</i>
                                  </button>
                                </td>
                            
                              </tr>
                            </template>
                          </tbody>
                        </table>
                        <span style="float: right; margin-right: 50px">
                          <label>{{ lang.WV0050 }}:</label>
                          <strong>{{ getTotalNumberOfVisits(selectedWave) }}</strong>
                        </span>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised"
                        style="float: left; margin-left: 20px"
                        @click="addNewBrandVisit(selectedWave)"
                        :disabled="!selectedWave.WaveName"
                      >
                        {{ lang.WV0047 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-success"
                        style="float: right; margin-right: 20px"
                        :class="{ 'btn-warning': selectedWaveDirty }"
                        @click="saveSelectedWave()"                        
                        :disabled="!canSaveWave()"
                      >
                        {{ lang.WV0010 }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.WV0015 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <WaveStatusModal></WaveStatusModal>
  </div>
</template>

<script>
import WaveStatusModal from "./WaveStatusModal";
import Select2 from "../Tools/Select2.vue";
const uuidv4 = require("uuid/v4");

export default {
  name: "WaveEditDialog",
  components: { Select2, WaveStatusModal },
  props: ["showDialog", "selectedClient", "selectedProjectData"],
  data() {
    return {
      waves: [],
      wavePositions: [],
      scenarios: [],
      leadAgencies: [],
      filteredWaves: [],
      filteredScenarios: [],
      carModelList: [],
      importerList: null,
      segmentList: null,
      filterWaveString: "",
      filterScenarioString: "",
      selectedTab: "editWaveTab",
      selectedWave: {},
      selectedWaveDirty: false,
      wavePositionsDirty: false,
      scenariosOfClient: [],
      fpInputWaveUntil: null,
      fpInputWaveSince: null,
      fpInputWavePlannedUntil:null, 
      fpInputWavePlannedSince : null,
      forceReportingVisibilityChange: false,
      brands: [],
      lang: {
        WV0000: "Wave Administration",
        WV0001: "Filter",
        WV0002: "ID",
        WV0003: "Name",
        WV0004: "Start date",
        WV0005: "End date",
        WV0006: "Edit wave",
        WV0007: "Assign scenarios",
        WV0008: "Reporting Visibility",
        WV0009: "New",
        WV0010: "Save",
        WV0011: "Delete",
        WV0012: "ID",
        WV0013: "Name",
        WV0014: "Description",
        WV0015: "Close",
        WV0016: "Yes",
        WV0017: "No",
        WV0018: "Delete Wave",
        WV0019: "Do you really want to delete the following wave?",
        WV0020: "Period of time",
        WV0021: "Change Reporting Visibility",
        WV0022:
          "Do you really want to make the whole wave visible in reporting?",
        WV0023:
          "All defined security settings on user level for this wave will be lost.",
        WV0024: "Project",
        WV0025: "Client",
        WV0026: "Save positions",
        WV0027: "Position",
        WV0028: "Cost center",
        WV0029: "Audi cars",
        WV0030: "Model",
        WV0031: "Share",
        WV0032: "Overall share values exceed 100%",
        WV0033: "Info",
        WV0034: "Status",
        WV0035: "Competitor Cars",
        WV0036: "Actions",
        WV0037: "Add model",
        WV0038: "Empty model already exists",
        WV0039: "Lead agency PLUS",
        WV0040: "Wave without approval",
        WV0041: "Local Wave",
        WV0042: "Planned start date",
        WV0043: "Planned end date",
        WV0044: "Brand",
        WV0045: "Visits",
        WV0046: "Frequency / Store",
        WV0047: "Add Visit",
        WV0048: "-- Choose --",
        WV0049: "Following competitors do not reach 100% Share: {{brands}}",
        WV0050: "Total",
        WV0051: "#Visits",
        WV0052: "Duplicated Frequency / Store for {{brand}} found.",
        WV0053: "Empty brand selection in 'Visits'.",
        WV0054: "Empty brand selection in 'Competitor Cars'.",
        WV0055: "All Visits for {{brand}} must be > 0.",
        WV0056: "Distribution value for a model set more than once!",
        WV0057: "Overall share values are below 99%",
        SA0012: "Importer",
        CMM002: "Segments",
      },
    };
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.initFlatpickr();
    }

    this.loadLeadAgencies();

    $("#editWaveDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("WaveDeleteModalYesConfirmation");
    this.globals.$on("WaveDeleteModalYesConfirmation", () => {
      this.deleteSelectedWave();
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("shopperApproval")) {
      this.globals.getCarModelList((data) => {
        this.carModelList = _.cloneDeep(data);
      });
      this.globals.getImporterList((data) => {
        this.importerList = data;
      });
      this.globals.getCarSegmentList((data) => {
        this.segmentList = data;
      });      
    }
  },
  destroyed() {
    if (this.fpInputWaveUntil) this.fpInputWaveUntil.destroy();
    if (this.fpInputWaveSince) this.fpInputWaveSince.destroy();
    if (this.fpInputWavePlannedSince) this.fpInputWavePlannedSince.destroy();
    if (this.fpInputWavePlannedUntil) this.fpInputWavePlannedUntil.destroy();
  },
  watch: {
    showDialog() {
      if (this.showDialog) this.openWaveEditDialog();
      else this.closeWaveEditDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.initFlatpickr();
    },
  },
  methods: {
    // Initialize flatpickr instances
    initFlatpickr() {
      this.fpInputWaveSince = flatpickr(
        "#inputWaveStartDate",
        this.globals.flatpickrDateConfig
      );
      this.fpInputWaveUntil = flatpickr(
        "#inputWaveEndDate",
        this.globals.flatpickrDateConfig
      );
      this.fpInputWavePlannedSince = flatpickr(
        "#inputWavePlannedStartDate",
        this.globals.flatpickrDateConfig
      );
      this.fpInputWavePlannedUntil = flatpickr(
        "#inputWavePlannedEndDate",
        this.globals.flatpickrDateConfig
      );
    },

    loadLeadAgencies() {
      $.ajax({
        method: "GET",
        url: "api/agencies/lead",
        success: (res) => {
          if (_.isEmpty(res)) res = [];
          this.leadAgencies = res;
        },
        error: () => {
          console.error("Error on GET in loadLeadAgencies()");
          this.globals.showErrorSnackbar("Lead agencies load failed");
        },
      });
    },
    loadBrands() {
      let queryString = `/api/data/Brands/${this.selectedProjectData.ProjectId}`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!_.isEmpty(data)) this.brands = data.map(p => p.LocationPropertyValue);
        },
        error: () => {
          console.error("Error on GET in getBrands()");
          this.globals.showErrorSnackbar("Brands get failed");
        },
      });
    },

    readCarModelDistributionFromSelectedWave() {
      this.clearCarModelDistribution();

      if (!this.selectedWave.CarModelDistribution) return;

      for (let waveEntry of this.selectedWave.CarModelDistribution) {
        let modelListEntry = _.find(
          this.carModelList,
          (model) => model.CarModelGuid === waveEntry.CarModelGuid
        );
        if (modelListEntry)
          modelListEntry.Distribution = parseFloat(
            (waveEntry.Distribution * 100).toFixed(4)
          );
      }
    },

    storeCarModelDistributionToSelectedWave() {
      let sum = 0;
      let modelsSet = new Set();
      this.selectedWave.CarModelDistribution = [];

      for (let entry of this.carModelList) {
        if (entry.Distribution === undefined) {
          continue;
        }

        if(modelsSet.has(entry.CarModelName)) {
          this.globals.showErrorSnackbar(this.lang.WV0056);
          console.error("Distribution value for a model set more than once!");
          return false;
        }

        sum += entry.Distribution;
        this.selectedWave.CarModelDistribution.push({
          CarModelGuid: entry.CarModelGuid,
          Distribution: parseFloat((entry.Distribution / 100).toFixed(4)),
        });

        modelsSet.add(entry.CarModelName);
      }

      if (this.selectedWave.CarModelDistribution.length < 1)
        delete this.selectedWave.CarModelDistribution;

      if (sum > 100) {
        this.globals.showErrorSnackbar(this.lang.WV0032);
        console.error(
          "Overall car model distribution values for this wave exceeds 100%"
        );
        return false;
      }

      if(sum < 99) {
        this.globals.showErrorSnackbar(this.lang.WV0057);
        console.error(
          "Overall car model distribution values for this wave is below 99%"
        );
        return false;
      }
      return true;
    },

    clearCarModelDistribution() {
      for (let entry of this.carModelList) delete entry.Distribution;
    },

    addCompetitorCarModel() {
      for (let entry of this.selectedWave.CompetitorCarModelDistribution)
        if (!entry.CompetitorCarModel) {
          this.globals.showErrorSnackbar(this.lang.WV0038);
          console.error("Empty competitor model already existis");
          return;
        }      
      this.selectedWave.CompetitorCarModelDistribution.push({
        CompetitorCarBrand:"",
        Distribution: 0
        });
      this.$forceUpdate();
    },

    deleteCompetitorCarModel(index) {
      _.pullAt(this.selectedWave.CompetitorCarModelDistribution, index);
      this.$forceUpdate();
    },

    validateDistributionValue(model, type) {
      let lowerLimit = 0,
        upperLimit = 100;
      if (type === "competitor") upperLimit = 1;

      if(model.Distribution === ''){
        model.Distribution = undefined;
      }
      else if (typeof model.Distribution !== "number" || model.Distribution < lowerLimit){
        model.Distribution = lowerLimit;
      }
      else if (model.Distribution > upperLimit) {
        model.Distribution = upperLimit;
      }
      this.$forceUpdate();
    },
    
    validateCompetitorCarModelDistribution() {
      if (this.selectedWave.CompetitorCarModelDistribution.length < 1) {
        delete this.selectedWave.CompetitorCarModelDistribution;
        return;
      }

      let map = this.getCompetitorCarBrandDistributionMap(this.selectedWave);
      let validationErrorMap = new Map([...map].filter(([key,value]) => value < 0.99 || value > 1));
      if(validationErrorMap.size > 0) {
        let brands = [...validationErrorMap.keys()].join(', ');
        this.globals.showErrorSnackbar(this.lang.WV0049.replace('{{brands}}', brands));
        console.error(
          `Following competitors do not have a share of 100% per brand: ${brands}`
        );
        return false;
      }
    },
    
    validateVisitValue(val){
      let lowerLimit = 1;
      let number = Number.parseInt(val);
      if (number < lowerLimit)
        return lowerLimit;
      if(!Number.isInteger(number))
        return Math.floor(number);
      return number;
    },

    showWaveStatus() {
      let config = {
        guid: this.selectedWave.WaveGuid,
        id: this.selectedWave.WaveId,
      };
      this.globals.$emit("showWaveStatus", config);
    },

    saveSelectedWave() {
      if (
        this.carModelList.length > 0 &&
        !this.storeCarModelDistributionToSelectedWave()
      )
        return;

      if(!this.validiateBrandSelections())
        return;

      if (
        this.selectedWave.CompetitorCarModelDistribution &&
        this.validateCompetitorCarModelDistribution() === false
      )
        return;

      if(!this.validateVisits())
        return;
      
      if (this.selectedWave.LeadAgencyId == "")
        this.selectedWave.LeadAgencyId = null;

      let data, queryString;
      let currentWaveIndex = _.findIndex(this.waves, (w) => {
        return w.WaveGuid === this.selectedWave.WaveGuid;
      });
      if (currentWaveIndex > -1) {
        // Wave does already exist
        queryString = `api/ProjectWaves/${this.selectedWave.WaveGuid}`;
        data = JSON.stringify(this.selectedWave);
        $.ajax({
          method: "PUT",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (!this.selectedWave.CompetitorCarModelDistribution)
              this.selectedWave.CompetitorCarModelDistribution = [];
            this.waves[currentWaveIndex] = _.cloneDeep(this.selectedWave);
            this.doFilteringWaves();
            this.$forceUpdate();
            this.globals.showSuccessSnackbar("Wave update successful");
            this.selectedWaveDirty = false;
          },
          error: (e) => {
            console.error("Error on PUT in saveSelectedWave()");
            this.globals.showErrorSnackbar("Wave update failed");
          },
        });
      } else {
        // Wave does not yet exist
        delete this.selectedWave.WaveId;
        this.selectedWave.WaveGuid = uuidv4();

        queryString = `api/Projects/${this.selectedProjectData.ProjectGuid}/Waves`;
        data = JSON.stringify([this.selectedWave]);

        $.ajax({
          method: "POST",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (data[0]) {
              if (data[0].WaveId) this.selectedWave.WaveId = data[0].WaveId;
              if (data[0].WaveGuid)
                this.selectedWave.WaveGuid = data[0].WaveGuid;
              if (data[0].WavePosition)
                this.selectedWave.WavePosition = data[0].WavePosition;
            }
            if (!this.selectedWave.CompetitorCarModelDistribution)
              this.selectedWave.CompetitorCarModelDistribution = [];
            let wave = _.cloneDeep(this.selectedWave);
            this.waves.push(wave);
            this.doFilteringWaves();
            this.$forceUpdate();
            this.globals.showSuccessSnackbar("Wave update successful");
            this.selectedWaveDirty = false;
          },
          error: () => {
            console.error("Error on POST in saveSelectedWave()");
            this.globals.showErrorSnackbar("Wave update failed");
          },
        });
      }
    },

    saveWavePositions() {
      let queryString = `api/Projects/${this.selectedProjectData.ProjectGuid}/Waves`;

      this.readWavePositions();
      let data = JSON.stringify(this.wavePositions);

      $.ajax({
        method: "PUT",
        url: queryString,
        data: data,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar("Wave position update successful");
          this.wavePositionsDirty = false;
        },
        error: () => {
          console.error("Error on PUT in saveWavePositions()");
          this.globals.showErrorSnackbar("Wave position update failed");
        },
      });
    },

    deleteSelectedWave() {
      $.ajax({
        method: "DELETE",
        url: "api/ProjectWaves/" + this.selectedWave.WaveGuid,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          this.globals.showSuccessSnackbar("Wave deletion successful");
          _.remove(this.waves, (w) => {
            return w.WaveGuid === this.selectedWave.WaveGuid;
          });
          this.createNewWave();
          this.closeWavePositionGap();
          this.doFilteringWaves();
        },
        error: () => {
          console.error("Wave deletion failed in deleteSelectedWave()");
          this.globals.showErrorSnackbar("Wave deletion failed");
        },
      });
    },

    createNewWave() {
      this.selectedWave = {
        WaveGuid: uuidv4(),
        ReportingVisibility: true,
        WaveWithoutApprovel: false,
        IsLocalWave: false,
        Scenarios: [],
        BrandVisits: []
      };
      this.fpInputWaveUntil.clear();
      this.fpInputWaveSince.clear();
      this.fpInputWavePlannedSince.clear();
      this.fpInputWavePlannedUntil.clear();
      this.clearCarModelDistribution();
      if (
        this.feature.isAudiTarget &&
        this.feature.isEnabled("shopperApproval")
      )
        this.selectedWave.CompetitorCarModelDistribution = [];
      this.selectedWaveDirty = false;
    },

    getAllWaves() {
      let queryString = `api/Projects/${this.selectedProjectData.ProjectGuid}/Waves`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!data || _.isEmpty(data)) {
            this.waves = [];
            return;
          }
          this.waves = data;
          this.sortWavesByPosition();
          this.doFilteringWaves();
        },
        error: () => {
          console.error("Error on GET in getAllWaves()");
          this.globals.showErrorSnackbar("Wave request failed");
        },
      });
    },

    getAllScenarios() {
      let queryString = "api/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.scenarios = data;
          this.getScenariosOfClient();
        },
        error: () => {
          console.error("Error on GET in getAllScenarios()");
          this.globals.showErrorSnackbar("Scenario request failed");
        },
      });
    },

    getScenariosOfClient() {
      let queryString = `/api/Clients/${this.selectedClient}/Scenarios`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.scenarios = this.scenarios.filter((sc) => {
            return _.indexOf(data.Scenarios, sc.ScenarioGuid) < 0
              ? false
              : true;
          });
          this.doFilteringScenarios();
        },
        error: () => {
          console.error("Error on GET in getScenariosOfClient()");
          this.globals.showErrorSnackbar("Scenario request failed");
        },
      });
    },

    doFilteringWaves() {
      // Reset filtering when search string is empty
      if (!this.waves || this.waves.length < 1) return;
      if (!this.filterWaveString) {
        this.filteredWaves = this.waves;
        return;
      }

      let words = this.filterWaveString.split(" ");
      let keys = ["WaveId", "WaveName", "WaveStart", "WaveEnd"];

      const waveFilter = (wave) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              wave[key] &&
              wave[key].toString().toLowerCase().indexOf(word.toLowerCase()) >
                -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredWaves = this.waves.filter(waveFilter);
    },

    reorderWaves() {
      let allPositions = _.range(1, this.waves.length + 1);
      let missingPos = 0;
      let newPos = 0;
      let waveGuid = "";

      // Find missing position number and the position and name of the changed wave
      for (var i = 0; i < allPositions.length; i++) {
        if (this.waves[i].WavePosition != allPositions[i]) {
          missingPos = allPositions[i];
          newPos = this.waves[i].WavePosition;
          waveGuid = this.waves[i].WaveGuid;
        }
      }
      if (missingPos == 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.waves[i].WaveGuid != waveGuid) {
          // Do NOT move the changed wave
          if (
            this.waves[i].WavePosition < missingPos &&
            this.waves[i].WavePosition >= newPos
          ) {
            this.waves[i].WavePosition++;
          }
          if (
            this.waves[i].WavePosition > missingPos &&
            this.waves[i].WavePosition <= newPos
          ) {
            this.waves[i].WavePosition--;
          }
        }
      }
      this.sortWavesByPosition();
      this.$forceUpdate(); // Forces the table to update
    },

    closeWavePositionGap() {
      if (this.waves.length < 1) return;
      this.waves[0].WavePosition = 1;
      for (let i = 1; i < this.waves.length; i++) {
        // Closes gap
        if (this.waves[i].WavePosition > this.waves[i - 1].WavePosition + 1)
          this.waves[i].WavePosition--;
        // Fixes double wave positions
        if (this.waves[i].WavePosition == this.waves[i - 1].WavePosition)
          this.waves[i].WavePosition++;
      }
    },

    sortWavesByPosition() {
      if (!this.waves) return;
      this.waves.sort((a, b) => {
        return a.WavePosition - b.WavePosition;
      });
    },

    readWavePositions() {
      this.wavePositions = [];
      for (let wave of this.waves) {
        this.wavePositions.push({
          WaveGuid: wave.WaveGuid,
          WavePosition: wave.WavePosition,
        });
      }
    },

    doFilteringScenarios() {
      // Reset filtering when search string is empty
      if (!this.scenarios || this.scenarios.length < 1) return;
      if (!this.filterScenarioString) {
        this.filteredScenarios = this.scenarios;
        return;
      }

      let words = this.filterScenarioString.split(" ");
      let keys = ["ScenarioId", "ScenarioName", "ScenarioDescription"];

      const scenarioFilter = (scenario) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              scenario[key] &&
              scenario[key]
                .toString()
                .toLowerCase()
                .indexOf(word.toLowerCase()) > -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredScenarios = this.scenarios.filter(scenarioFilter);
    },

    selectWave(WaveGuid) {
      let wave = this.waves.find((w) => {
        return w.WaveGuid === WaveGuid;
      });
      if (wave) {
        this.selectedWave = _.cloneDeep(wave);
        if (this.carModelList.length > 0)
          this.readCarModelDistributionFromSelectedWave();
        if (
          this.feature.isAudiTarget &&
          this.feature.isEnabled("shopperApproval") &&
          !this.selectedWave.CompetitorCarModelDistribution
        )
          this.selectedWave.CompetitorCarModelDistribution = [];
        this.fpInputWaveSince.setDate(this.selectedWave.WaveSince);
        this.fpInputWaveUntil.setDate(this.selectedWave.WaveUntil);
        this.fpInputWavePlannedSince.setDate(this.selectedWave.WavePlannedSince);
        this.fpInputWavePlannedUntil.setDate(this.selectedWave.WavePlannedUntil);
        this.selectedWaveDirty = false;
      } else{
        this.createNewWave();
      } 
    },

    isWaveSelected(WaveGuid) {
      return this.selectedWave.WaveGuid === WaveGuid;
    },

    selectScenario(scenarioGuid) {
      if (!this.selectedWave.WaveId) return;
      if (!this.selectedWave.Scenarios)
        this.selectedWave.Scenarios = [scenarioGuid];
      else {
        let idx = _.indexOf(this.selectedWave.Scenarios, scenarioGuid);
        if (idx > -1) {
          _.pullAt(this.selectedWave.Scenarios, idx);
        } else {
          this.selectedWave.Scenarios.push(scenarioGuid);
        }
      }
      this.selectedWaveDirty = true;
      this.$forceUpdate();
    },

    isScenarioSelected(scenarioGuid) {
      return _.indexOf(this.selectedWave.Scenarios, scenarioGuid) > -1;
    },

    openDeleteWaveConfirmationDialog() {
      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getDeleteDialogData()
      );
    },

    getDeleteDialogData() {
      return {
        initiator: "WaveDeleteModal",
        confirmationTitle: this.lang.WV0018,
        colorRed: true,
        yesButtonText: this.lang.WV0016,
        noButtonText: this.lang.WV0017,
        htmlText: `<p><b>${this.lang.WV0019}</b></p>
        <div class="form-group">
          <label class="col-md-3 text-black">${this.lang.WV0002}</label>
          <label class="col-md-9 text-black">${this.selectedWave.WaveId}</label>
        </div>
        <div class="form-group">
          <label class="col-md-3 text-black">${this.lang.WV0003}</label>
          <label class="col-md-9 text-black">${
            this.selectedWave.WaveName
          }</label>
        </div>
        <div class="form-group">
          <label class="col-md-3 text-black">${this.lang.WV0020}</label>
          <label class="col-md-9 text-black">${this.globals.getLocalizedDateFromIsoTimestamp(
            this.selectedWave.WaveSince
          )} - ${this.globals.getLocalizedDateFromIsoTimestamp(
          this.selectedWave.WaveUntil
        )}</label>
        </div>`,
      };
    },

    openWaveEditDialog() {
      this.wavePositionsDirty = false;
      this.filteredWaves = [];
      this.createNewWave();
      this.getAllWaves();
      this.getAllScenarios();
      this.loadBrands();
      $("#editWaveDialog").modal("show");
    },

    closeWaveEditDialog() {
      $("#editWaveDialog").modal("hide");
    },
    waveReportingVisibilityChanged(wave) {
      if (wave.ReportingVisibility === false) return;
      let forceReportingVisibilityChange = false;

      this.globals.$off("WaveReportingVisibilityChangedModalYesConfirmation");
      this.globals.$on(
        "WaveReportingVisibilityChangedModalYesConfirmation",
        () => {
          wave.ReportingVisibility = true;
          forceReportingVisibilityChange = true;
        }
      );
      this.globals.$off("WaveReportingVisibilityChangedModalDialogClosed");
      this.globals.$on(
        "WaveReportingVisibilityChangedModalDialogClosed",
        () => {
          if (!forceReportingVisibilityChange) wave.ReportingVisibility = false;
          forceReportingVisibilityChange = false;
        }
      );
      this.openReportingVisibilityChangedDialog();
    },

    openReportingVisibilityChangedDialog() {
      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getReportingVisibilityChangedDialogData()
      );
    },

    getReportingVisibilityChangedDialogData() {
      return {
        initiator: "WaveReportingVisibilityChangedModal",
        confirmationTitle: this.lang.WV0021,
        colorRed: true,
        yesButtonText: this.lang.WV0016,
        noButtonText: this.lang.WV0017,
        htmlText: `<p><b>${this.lang.WV0022}</b></p>
        <p>${this.lang.WV0023}</p>`,
      };
    },

    addNewBrandVisit(wave) {
      if(!wave.BrandVisits)
        wave.BrandVisits = [];
      wave.BrandVisits.push({ BrandName:"", Visits: [this.getEmptyVisit()]});
    },
    addVisitToBrandVisit(brandVisit) {
      brandVisit.Visits.push(this.getEmptyVisit());
    },
    getEmptyVisit() {
      return {Frequency: 0, NoOfVisits: 0};
    },
    canSelectBrand(wave, brandName) {
      return wave.BrandVisits.find(p => p.BrandName === brandName);
    },
    removeBrandVisit(wave, index) {
      wave.BrandVisits.splice(index, 1);
    },
    removeVisit(wave, brandIndex, index) {
      wave.BrandVisits[brandIndex].Visits.splice(index, 1);
    },
    getTotalNumberOfVisits(wave){
      if(!wave || !wave.BrandVisits) return 0;
      let result = 0;
      for (let brandVisit of wave.BrandVisits){
        if(!brandVisit.Visits)
          continue;
        brandVisit.Visits.forEach(v => result += (v.Frequency * v.NoOfVisits))
      }
      return result;
    },
    getCompetitorCarBrandDistributionMap(){
      let result = new Map();

      if(!this.selectedWave || !this.selectedWave.CompetitorCarModelDistribution)
        return result;

      for(let competitorCar of this.selectedWave.CompetitorCarModelDistribution) {
        result.set(competitorCar.CompetitorCarBrand, (result.get(competitorCar.CompetitorCarBrand) || 0) + (competitorCar.Distribution || 0));
      }
      return result;
    },
    getCompetitorDistributionsInfoToolTip(){
      let map = this.getCompetitorCarBrandDistributionMap();
      return [...map.entries()].map(p => `${p[0]}: ${(p[1]*100).toFixed(1)}%`);
    },
    validateVisits() {
      if(!this.selectedWave || !this.selectedWave.BrandVisits) return true;

      for(let brandVisit of this.selectedWave.BrandVisits) {
        if(brandVisit.Visits.findIndex(p => p.NoOfVisits <= 0 || p.Frequency <= 0 || Number.isNaN(p.NoOfVisits) || Number.isNaN(p.Frequency)) >= 0){
          console.error(`0 Value in Visit for Brand ${brandVisit.BrandName}`);
          this.globals.showErrorSnackbar(this.lang.WV0055.replace('{{brand}}', brandVisit.BrandName));
          return false;
        }

        let visitSet = new Set(brandVisit.Visits.map(p => p.Frequency.toString()));
        if(visitSet.size != brandVisit.Visits.length){
          console.error(`Duplicated Frequency for Brand ${brandVisit.BrandName}`);
          this.globals.showErrorSnackbar(this.lang.WV0052.replace('{{brand}}', brandVisit.BrandName));
          return false;
        }
      }
      return true;
    },
    canSaveWave() {
      return this.selectedWave.WaveName &&
        this.selectedWave.WaveSince &&
        this.selectedWave.WaveUntil && 
        this.selectedWave.WavePlannedSince &&
        this.selectedWave.WavePlannedUntil &&
        ((this.globals.isAccessAllowed('LoopOp_ProjectWaves_Create') && !this.selectedWave.WaveId) ||
        (this.globals.isAccessAllowed('LoopOp_ProjectWaves_Update') && this.selectedWave.WaveId))
    },
    canRemoveVisit(wave, brandIndex) {
      if(!wave || brandIndex == undefined || brandIndex < 0 || !wave.BrandVisits[brandIndex])
        return false;
      return wave.BrandVisits[brandIndex].Visits.length > 1;
    },
    validiateBrandSelections() {
      let messages = [];
      if(this.selectedWave.BrandVisits.findIndex(p => p.BrandName == "") >= 0) {
        console.error(this.lang.WV0053);
        messages.push(this.lang.WV0053);
      }
      if(this.selectedWave.CompetitorCarModelDistribution.findIndex(p => p.CompetitorCarBrand == "") >= 0){
        console.error(this.lang.WV0054);
        messages.push(this.lang.WV0054);
      }
      
      if(messages.length > 0){
        this.globals.showErrorSnackbar(messages.join(' '));
        return false;
      }
      return true;
    }
    }
};
</script>

<style scoped>
.modal-lg {
  width: calc(100vw - 300px);
}

.table-container {
  height: calc(100vh - 355px);
  overflow-y: auto;
}
.table-waves {
  height: calc(100vh - 300px);
}

.select2-container--below {
  width: auto !important;
}
.modal-content {
  background-color: #eee;
}

#editWaveDialog .panel-body {
  padding: 0 !important;
}

.modal-footer .btn-default {
  background: rgb(190, 190, 190);
}

.btn-top-bar.btn.btn-raised.btn-success:not(:disabled) {
  background-color: #4caf50;
}
.btn.btn-raised.btn-success:hover:not(:disabled) {
  background-color: #59b75c;
}
.btn-top-bar.btn.btn-raised.btn-warning:not(:disabled) {
  background-color: #ff5722;
}
.btn.btn-raised.btn-warning:hover:not(:disabled) {
  background-color: #ec5122ab;
}
.lead-agency-dropdown {
  width: auto;
}
/* Tabs for wave edit mode */
.nav-wave-edit {
  background-color: var(--color-primary);
  padding: 0px;
}
.nav-wave-edit > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav-wave-edit > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}
.nav-wave-edit > li.active > a {
  font-weight: bold;
}

.form-group {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// WaveEditModal.vue?3673f12b